import { render } from "./BoardInput.vue?vue&type=template&id=16a9adc8"
import script from "./BoardInput.vue?vue&type=script&lang=js"
export * from "./BoardInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__